type Listener = () => void

const listeners = new Set<Listener>()

export const emitEhrSessionInvalidated = () => {
  listeners.forEach((listener) => listener())
}

export const subscribeToEhrSessionInvalidation = (listener: Listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
